<div class="marginrl30">
  <div class="contentTop">
    <div class="title">Data Monitoring Console</div>

    <div>
      <div>
        <button class="contentTop-Button" (click)="onRefreshClick()">
          Refresh Screen
        </button>
      </div>
    </div>
  </div>

  <div class="statusCardDetails">
    <div class="cardBlock">
      <div class="card">
        <div class="cardData">
          <div class="cardIcon green" style="text-align: center">
            <fa-icon [icon]="faCompleted" class="iconInprogress"></fa-icon>
          </div>
          <div class="cardText">
            <span class="cardCount">{{ statusCount.Completed }}</span><label class="labelName">Completed</label>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="cardData">
          <div class="red cardIcon">
            <fa-icon [icon]="faError" class="iconInprogress"></fa-icon>
          </div>
          <div class="cardText">
            <span class="cardCount">{{ statusCount.InError }}</span><label class="labelName">In Error</label>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="cardData">
          <div class="blue cardIcon">
            <fa-icon [icon]="faInprogres" class="iconInprogress"></fa-icon>
          </div>
          <div class="cardText">
            <span class="cardCount">{{ statusCount.InProgress }}</span><label class="labelName">In
              Progress</label>
          </div>
        </div>
      </div>
    </div>
  </div>


<div id="styleGrid" class="mt-20">
  <kendo-grid [kendoGridBinding]="gridData" [pageSize]="20" [pageable]="true" [height]="500" filterable="menu"
    [resizable]="true" [sortable]="true" [sort]="sort" [reorderable]="true" >
    <kendo-grid-column field="rowNumber" title="#" [width]="30" [filterable]="false" [sortable]="false">
      <ng-template kendoGridCellTemplate let-rowIndex="rowIndex">{{
        rowIndex + 1
        }}</ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="tableName" [width]="130" class="text-align-left" title="Table Name">
    </kendo-grid-column>
    <kendo-grid-column field="status" title="Status" class="text-align-left" [width]="60">
    </kendo-grid-column>
    <kendo-grid-column field="functionName" title="Function" class="text-align-left" [width]="60">
    </kendo-grid-column>
    <kendo-grid-column field="lastUpdated" title="Last Updated" class="text-align-left" [width]="100" format="{0:MM/dd/yyyy HH:mm:ss}"
      filter="date">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span>{{ dataItem.lastUpdated | date:'dd-MM-yyyy hh:mm a' }}</span>
        <!-- <span>{{ dataItem.lastUpdated }}</span> -->
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="currentRecords" title="Current Records(After Load)" class="text-align-right"  [width]="120"></kendo-grid-column>
    <kendo-grid-column field="cachedRecords" title="Current Records(Before Delete)" class="text-align-right"  [width]="120"></kendo-grid-column>
    <kendo-grid-column field="description" title="Description" class="text-align-left" [width]="200"></kendo-grid-column>
  </kendo-grid>
</div>

</div>